import React, { Routes, Route } from "react-router-dom";
import { Status } from "./pages/Status";

function App () {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Status />} />
      </Routes>
    </div>
  );
}

export default App;
